import { getIndexName } from '../../../../../constants';
import { generateUrlFromIndexUiState } from '../../../../../utils/algolia/url-handling';
import { LOCALIZED_PATHS } from '../../../../../utils/constants/url-constants';

type SupportedLocale = 'en' | 'fi' | 'sv';

function toSupportedLocale(locale: string): SupportedLocale {
  const normalized = locale.toLowerCase();
  if (normalized === 'fi' || normalized === 'sv') return normalized;
  return 'en';
}

export function buildSimilarJobsSrpHref(params: {
  locale: string;
  normalisedTitle?: string | null;
  primaryLocation?: string | null;
}): string {
  const locale = toSupportedLocale(params.locale);
  const basePath = `/${locale}/${LOCALIZED_PATHS[locale].jobs}`;
  const title = (params.normalisedTitle ?? '').trim();
  if (!title) return basePath;

  const location = (params.primaryLocation ?? '').trim();
  const refinementList: Record<string, string[]> = {
    normalisedTitle: [title],
  };
  if (location) {
    refinementList.location = [location];
  }

  return generateUrlFromIndexUiState(
    { refinementList },
    getIndexName(locale),
    basePath,
  );
}

